export { BaseControl } from './component';
export type { BaseControlProps } from './types';
